import React from "react"
import PulsingLoader from "./ui/PulsingLoader"
import ArticleContent from "./ui/ArticleContent"
import CategoryContent from "./ui/CategoryContent"
import Typography from "aldoo-ra/Typography"


/**
 * Main Content Component
 * Displays the main content area with loading states, error handling,
 * and the appropriate content type (article or category)
 */
const MainContent = ({
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  return (
    <div className="w-full lg:w-4/5 lg:ml-14 overflow-y-auto mx-auto lg:mx-0">
      <div>
        {isLoading ? (
          <div className="flex justify-center items-center h-40">
            <PulsingLoader />
          </div>
        ) : error ? (
          <div className="border border-red-200 rounded p-4">
            <Typography variant="error">
              {error}
            </Typography>
          </div>
        ) : (
          contentType === "article" ? (
            <ArticleContent article={selectedContent} onFeedback={onFeedback} />
          ) : (
            <CategoryContent
              category={selectedContent}
              onNavigate={navigateTo}
            />
          )
        )}
      </div>
    </div>
  )
}

export default MainContent
